module.exports = __webpack_public_path__ + "static/media/addEventActive.f4c254ee.svg";